<template>
    <div class="avatar-container" :class="{ admin: permission == 'admin', owner: permission == 'owner' }">
        <b-avatar v-if="user" id="custom-avatar" :class="{ 'remove-background': user.image }" :size="size" :src="user.image" :text="getFullnameInitials">
        </b-avatar>
        <b-avatar v-else-if="!user && !link" id="custom-avatar" :size="size"></b-avatar>
        <b-avatar v-else-if="link" id="custom-avatar" class="icon">
            <icon name="ci-link" color="var(--accent)" />
        </b-avatar>
        <div
            v-if="permission == 'owner' || permission == 'admin'"
            class="avatar-badge d-flex justify-content-center align-items-center"
            :style="`background-color: ${permission == 'owner' ? 'var(--semantic-yellow-dark)' : 'var(--secondary)'}`"
        >
            <icon v-show="permission == 'owner'" class="key" name="key" color="white" scale=".5" />
            <icon v-show="permission == 'admin'" class="star" name="star" color="white" scale=".5" />
        </div>
    </div>
</template>

<script>
import 'vue-awesome/icons/star'
import 'vue-awesome/icons/key'

export default {
    props: {
        user: Object,
        size: String,
        link: {
            type: Boolean,
            default: false,
        },
        permission: {
            type: String,
            default: '',
        },
    },
    computed: {
        getFullnameInitials() {
            return this.user.name.slice(0, 1) + ' ' + this.user.surname.slice(0, 1)
        },
    },
}
</script>

<style lang="scss">
#custom-avatar {
    flex-shrink: 0;
    background-color: var(--accent);
    &.icon {
        background-color: var(--primary-2);
        svg {
            fill: var(--accent);
        }
    }
    &.remove-background {
        background-color: transparent;
    }
}

.avatar-container {
    margin: 8px;
    position: relative;
    .b-avatar {
        background-color: var(--secondary-3);
        border: 2px solid transparent;
    }
    &.admin {
        .b-avatar {
            border: 2px solid var(--secondary);
        }
    }
    &.owner {
        .b-avatar {
            border: 2px solid var(--semantic-yellow-dark);
        }
    }
    .avatar-badge {
        position: absolute;
        top: 18px;
        left: 18px;
        border-radius: 50%;
        height: 20px;
        width: 20px;
        border: 2px solid var(--primary-4);
        background-color: var(--semantic-yellow-dark);
    }
}
</style>
